import React, { useState, useEffect, useMemo } from 'react';
import './AdminDashboard.css';
import { FaFeather, FaBrush, FaStar } from 'react-icons/fa'; 
import axiosInstance from '../../axiosInstance';
import Card from './Card';
import ChartComponent from './ChartComponent';

const API_URL = process.env.REACT_APP_API_URL;

function AdminDashboard() {
  const [cards, setCards] = useState([]);

  const cardOrder = useMemo(() => ['Clients', 'Expenses', 'Revenue'], []); 
  
  const iconMap = {
    Revenue: <FaFeather />,
    Expenses: <FaBrush />,
    Clients: <FaStar />,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`${API_URL}/api/data`);
        const data = response.data;

        const combinedCards = (data.cards || []).filter(card => 
          ['Clients', 'Revenue', 'Expenses' ].includes(card.name)
        );

        const sortedCards = combinedCards.sort((a, b) => 
          cardOrder.indexOf(a.name) - cardOrder.indexOf(b.name)
        );

        setCards(sortedCards);
      } catch (error) {
        console.error('Error fetching API data', error);
      }
    };

    fetchData();
  }, [cardOrder]);

  const getCardClass = useMemo(() => {
    return (amount, name) => {
      if (name === 'Revenue') {
        if (amount <= 600) return 'card-danger';
        if (amount >= 601 && amount <= 999) return 'card-white';
        return 'card-white';
      }
      return 'card-white';
    };
  }, []);

  const getAmountClass = useMemo(() => {
    return (amount, name) => {
      if (name === 'Revenue') {
        if (amount <= 600) return ' admin-text-danger';
        if (amount > 1000) return 'admin-text-success';
        return 'text-warning';
      }
      if (name === 'Clients') {
        return amount < 10 ? 'admin-text-danger' : 'admin-text-success';
      }
      if (name === 'Expenses') {
        return amount <= 100 ? 'admin-text-success' : 'admin-text-danger';
      }
      return '';
    };
  }, []);

  if (cards.length === 0) {
    return <div>Loading...</div>;
  }
return (
    <section className="dashboard section">
      <div className="dashboard-container">
        {/* Small cards row */}
        <div className="small-cards-row">
          {cards.map((card) => (
            <Card
              iconMap={iconMap}
              key={card._id}
              card={{ 
                ...card,
                amount: card.name === 'Clients' 
                  ? parseInt(card.amount).toLocaleString()
                  : parseFloat(card.amount).toLocaleString('en-US', { 
                      style: 'currency', 
                      currency: card.currency_code || 'USD' 
                    })
              }}
              className={getCardClass(card.amount, card.name)}
              amountClass={getAmountClass(card.amount, card.name)}
            />
          ))}
        </div>

        {/* Large card row with chart */}
        <div className="large-card-row">
          <div className="chart-container">
            <ChartComponent />
          </div>
        </div>
      </div>
    </section>
  );
}
export default AdminDashboard;

